import script from "./IndicatorsStatisticTariffs.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndicatorsStatisticTariffs.vue?vue&type=script&setup=true&lang=ts"

import "./IndicatorsStatisticTariffs.vue?vue&type=style&index=0&id=396d7c38&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396d7c38"]])

export default __exports__